import { render } from "./VerificationPaymentTransfer.vue?vue&type=template&id=5c41ba6c"
const script = {}

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__